import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ToastrService } from 'ngx-toastr';
import { Rol, Tarea, Asignacion } from '@app/shared';
import { EndpointService } from '@app/core';

@Injectable()
export class AssignmentService {
  constructor(private http: HttpClient, private toastr: ToastrService, private api: EndpointService) {}

  /**
   * Consulta un rol(grupo).
   *
   * @param {number} idRol
   * @returns {Observable<Rol>}
   * @memberof AssignmentService
   */
  getRole(idRol: number): Observable<Rol> {
    return this.http.get<Rol>(this.api.get('roles', [idRol]));
  }

  /**
   * Realiza la asignación de una tarea.
   *
   * @param {Tarea} tarea
   * @param {number[]} responsibles
   * @returns {Observable<boolean>}
   * @memberof AssignmentService
   */
  assign(tarea: Tarea, responsibles: number[]): Observable<boolean> {
    const data = {
      tarea: tarea.id,
      responsable: responsibles
    };
    return new Observable(obs => {
      this.http.post(this.api.get('assignment'), data, { observe: 'response' }).subscribe(
        res => {
          if (res.status === 200) {
            obs.next(true);
            this.toastr.success(`La asignación se realizó correctamente.`, 'Operación exitosa');
          } else {
            obs.next(false);
          }
          obs.complete();
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   * Consulta el historial de asignaciones
   *
   * @param {number} id
   * @returns {Observable<Asignacion>}
   * @memberof AssignmentService
   */
  getHistoryAssign(id: number): Observable<Asignacion> {
    return new Observable(obs => {
      this.http.get<Asignacion>(this.api.get('historyTask', [id])).subscribe(
        res => {
          obs.next(res);
          obs.complete();
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   * Realiza la asignación de lso responsables de una tarea y finalizar la carga de datos.
   *
   * @param {Tarea} tarea
   * @param {number[]} responsibles
   * @returns {Observable<boolean>}
   * @memberof AssignmentService
   */
  finishDataLoad(tarea: Tarea, responsibles: number[]): Observable<boolean> {
    const data = {
      responsables: responsibles
    };
    return new Observable(obs => {
      this.http.put(this.api.get('dataCharge', [tarea.id]), data, { observe: 'response' }).subscribe(
        res => {
          if (res.status === 200) {
            obs.next(true);
            this.toastr.success(`La asignación se realizó correctamente.`, 'Operación exitosa');
          } else {
            obs.next(false);
          }
          obs.complete();
        },
        err => {
          obs.error(err);
        }
      );
    });
  }
} // End class



// WEBPACK FOOTER //
// ./src/app/forms/shared/assignment/shared/assignment.service.ts